export default __webpack_public_path__ + "static/media/Ultraman_04.38df59db.png";